<template>
  <div class="box">
    <!-- <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1>
    <h1>List Page</h1> -->
    <BackTop />
  </div>
</template>

<script>
import BackTop from '@/components/BackTop.vue'

export default {
  name: 'ProductList',
  components: {
    BackTop
  }
}
</script>

<style scoped type="text/less" lang="less">
.box {
  width: 100%;
  text-align: center;
}
</style>
